export default {
  user: (state) => {
    return state.user;
  },
  data: (state) => {
    return state.data;
  },
  list: (state) => {
    return state.list;
  },
  userData: (state) => {
    return state.userData;
  },
  staff: (state) => {
    let users = JSON.parse(JSON.stringify(state.list));
    return users.filter((u) => u.email.includes("@upstreamnz.co.nz"));
  },
};
